import VisioptTrackingComponent from "../../shared/widgets/visitoptTracking";

const VISITOPT_SITE_ID = "814";

const pathnameToVisitoptPathID = new Map([
  //   BB related paths
  ["/visits/pac/signup", 2],
  ["/visits/pac/signup-details", 22],
  ["/visits/pac/1", 23],
  // ["/visits/pac/17", 23],
  ["/visits/pac/select-pharmacy", 24],
  // ["/visits/pac/select-product", 23],
  ["/visits/pac/payment/order-details", 25],
  ["/visits/pac/payment/payment-details", 26],
  ["/visits/pac/payment/complete", 27],

  // Insomnia related
  ["/visits/inc/signup", 99],
  ["/visits/inc/signup-details", 99],
  ["/visits/inc/1", 99],
  ["/visits/inc/payment", 99],
  ["/visits/inc/payment/complete", 99],
]);

const VisitsVisioptTracking = (props) => {
  // Map window.location.pathname to visitopt page ID
  function getPageIDFromPath(path) {
    return pathnameToVisitoptPathID.get(path) || "";
  }

  var pageID = getPageIDFromPath(window.location.pathname);

  return pageID ? (
    <VisioptTrackingComponent siteId={VISITOPT_SITE_ID} pageId={pageID} />
  ) : (
    false
  );
};

export default VisitsVisioptTracking;
